import { render, staticRenderFns } from "./LookTeacher.vue?vue&type=template&id=61234142&scoped=true&"
import script from "./LookTeacher.vue?vue&type=script&lang=js&"
export * from "./LookTeacher.vue?vue&type=script&lang=js&"
import style0 from "./LookTeacher.vue?vue&type=style&index=0&id=61234142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61234142",
  null
  
)

export default component.exports